import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {Link} from "react-router-dom";
import {TopAlertInformacja} from "../../../componentsTopsa/alerty/TopAlerts";
import qr_code from "../../../resources/images/qr-codes-android/client.png";
import googleplay from "../../../images/marcelgoogleplay.jpg";

export default class AplikacjaDlaKlientow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'AplikacjaDlaKlientow'}>

                        <Row>
                            <Col sm={12}>
                                <div id="subheader">
                                    <TopBreadcumb links={[{addressUrl: '/aplikacjeandroid', text: 'Aplikacje Android'},
                                        {addressUrl: '/aplikacjeandroid/aplikacja-kliencka', text: 'Aplikacja dla klientów'}]}/>
                                    <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                               history={this.props.history}/>
                                </div>
                            </Col>
                            <Col sm={6}>
                                <Row>
                                    <Col sm={12}>

                                        <h3>Aplikacja Android TOP eBus dla klientów</h3>
                                        <TopAlertInformacja text={"Aby pobrać aplikację zeskanuj poniższy kod QR"}/>
                                        <div className={"thumbnail"} style={{width: "300px", padding: "50px"}}>
                                            <img src={qr_code} className={"img-responsive"} style={{width: "100%"}}/>
                                        </div>

                                    </Col>

                                    <Col sm={12}>
                                        <a href={"http://gw1.topsa.com.pl/android/get/marcel/clientMarcel/prod/"}>
                                            <code>http://gw1.topsa.com.pl/android/get/marcel/clientMarcel/prod/</code>
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={6}>
                                <Col sm={12}>
                                    <h3>Aplikacja Android TOP eBus dla klientów w sklepie Google Play</h3>
                                    <TopAlertInformacja text={"Aby pobrać aplikację z sklepu Google Play, kliknij w poniższy link"}/>
                                    <div className={"thumbnail"} style={{width: "300px", padding: "50px"}}>
                                        <img src={googleplay} className={"img-responsive"} style={{width: "100%"}}/>
                                    </div>
                                </Col>
                                    <Col sm={12}>
                                        <a href={"https://play.google.com/store/apps/details?id=com.react_marcel"}>
                                            <code>https://play.google.com/store/apps/details?id=com.react_marcel</code>
                                        </a>
                                    </Col>
                            </Col>
                        </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/aplikacjeandroid/dla-klientow/AplikacjaDlaKlientow.js